"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineLogTitle = void 0;
const dayjs = require("dayjs");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineLogTitle = (item) => {
    if (!item.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return null;
    switch (item.type) {
        case "GOLF": {
            const config = latest_version.config;
            if (!config?.product?.config?.holes)
                return `Golf at ${config?.course?.name?.en}${config?.product?.custom ? " (Custom)" : ""} - ${dayjs(latest_version?.start_date).format("DD MMM [‘]YY")}`;
            return `${config?.product?.config?.holes} Holes at ${config?.course?.name?.en}${config?.product?.custom ? " (Custom)" : ""} - ${dayjs(latest_version?.start_date).format("DD MMM [‘]YY")}`;
        }
        case "HOTEL": {
            const config = latest_version.config;
            return `${config.where_when_who.hotel?.name?.en} - ${dayjs(latest_version?.start_date).format("DD MMM [‘]YY")} (${config?.where_when_who?.number_of_nights}N)`;
        }
        case "EXCURSION": {
            const config = latest_version.config;
            return `${config?.product?.excursion?.name?.en} - ${dayjs(latest_version?.start_date).format("DD MMM [‘]YY")}`;
        }
        case "TRANSFER": {
            const config = latest_version.config;
            const airport_transfer = config.transfer_legs.inbound.from_type === "Airport" ||
                config.transfer_legs.outbound.from_type === "Airport" ||
                config.transfer_legs.inbound.to_type === "Airport" ||
                config.transfer_legs.outbound.to_type === "Airport";
            const passenger_name = airport_transfer
                ? `(${config.where_when_who.pickup_name})`
                : "";
            const custom = config?.vehicle?.rate?.type === "CUSTOM" ? " (Custom)" : "";
            switch (config.where_when_who.type) {
                case "ONE_WAY":
                    return `${config?.transfer_legs?.outbound?.from_name} > ${config?.transfer_legs?.outbound?.to_name} ${custom} - ${dayjs(latest_version?.start_date).format("DD MMM [‘]YY")}`;
                case "RETURN":
                    return `${config?.transfer_legs?.outbound?.from_name} > ${config?.transfer_legs?.outbound?.to_name} (Return) ${custom} - ${dayjs(latest_version?.start_date).format("DD MMM [‘]YY")}`;
                case "CUSTOM":
                    return `${config?.transfer_legs?.outbound?.from_name} > ${config?.transfer_legs?.outbound?.to_name} > ${config?.transfer_legs?.inbound?.to_name} ${passenger_name}${custom} - ${dayjs(latest_version?.start_date).format("DD MMM [‘]YY")}`;
            }
            return "";
        }
        case "CUSTOM": {
            const config = latest_version.config;
            if (config?.where_when_who?.type === "EXTRA") {
                return `${config.where_when_who.title} - ${dayjs(latest_version?.start_date).format("DD MMM [‘]YY")}`;
            }
            return `${config.where_when_who.title} - ${dayjs(latest_version?.start_date).format("DD MMM [‘]YY")}`;
        }
    }
};
exports.getOrderLineLogTitle = getOrderLineLogTitle;
